import React, { useMemo } from 'react';
import { CalendarFieldStyled, Label, CaretDownIcon, StyledCalendarIcon } from './styles';
import { useIntl } from 'react-intl';
import { Moment } from 'moment';
import { faCalendar } from '@fortawesome/pro-regular-svg-icons/faCalendar';
import { useLocale } from 'hooks/use-locale.hook';
import { formatLongDate } from 'utils/formatDate';

interface DatePickerInputProps {
  value: Moment | null;
  setIsOpenedTrue?: VoidFunction;
  inputRef?: React.MutableRefObject<HTMLDivElement>;
  formattedDate: string;
  onClick?: VoidFunction;
  isDisabled?: boolean;
}

export const DatePickerInput = ({
  value,
  setIsOpenedTrue,
  inputRef,
  formattedDate,
  onClick,
  isDisabled,
}: DatePickerInputProps): JSX.Element => {
  const intl = useIntl();
  const locale = useLocale();

  const getLabel = useMemo(() => {
    if (formattedDate) return formattedDate;

    // CLDR owns the field order — `moment(value).format('MMMM DD, YYYY')` is hard-wired to US
    // month-day-year, so fr-FR read `septembre 13, 2026` instead of `13 septembre 2026`.
    return value ? formatLongDate(value.format('YYYY-MM-DD'), locale) : intl.formatMessage({ id: 'selectDate' });
  }, [formattedDate, value, locale, intl]);

  return (
    <CalendarFieldStyled
      className="date-picker-select"
      data-testid="date-picker-select"
      isEmpty={!value}
      onClick={setIsOpenedTrue || onClick}
      ref={inputRef}
      isDisabled={isDisabled}
    >
      <StyledCalendarIcon icon={faCalendar} data-testid="nothing-available-now-icon" size="1x" />
      <Label>{getLabel}</Label>
      <CaretDownIcon variant="adminGreyDark" className="caret" />
    </CalendarFieldStyled>
  );
};
